
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from "../../api/axiosInstance";
// 663700
// Async thunk to handle the API call
export const requestNewCustomer = createAsyncThunk(
  "customer/requestNewCustomer",
  async ({finalData,language}, { rejectWithValue }) => {
    try {
      const { email, ...rest } = finalData;
      const payload = email ? { ...rest, email } : rest;
      const response = await axiosInstance.post("/api/Customer/RequestNewCustomer", payload, {
        headers: {
            'Content-Type': 'application/json',
            "lang": language === "English" ? "2" : "1",
          },
      });
      return response.data; // Success response
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
// Initial state
const initialState = {
  loading: false,
  success: null,
  error: null,
};

// Customer slice
const customerSlice = createSlice({
  name: "customer",
  initialState,
  reducers: {
    resetStatus: (state) => {
      state.success = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(requestNewCustomer.pending, (state) => {
        state.loading = true;
        state.success = null;
        state.error = null;
      })
      .addCase(requestNewCustomer.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload;
        state.error = null;
      })
      .addCase(requestNewCustomer.rejected, (state, action) => {
        state.loading = false;
        state.success = null;
        state.error = action.payload;
      });
  },
});

export const { resetStatus } = customerSlice.actions;
export default customerSlice.reducer;
